import { useQuery } from '@tanstack/react-query';
import { AdminScanSequencesService } from '../services/admin/admin-scan-sequences.service';

export function useAdminScanSequence(scanSequenceId: string | undefined) {
  return useQuery({
    queryKey: ['admin-scan-sequence', scanSequenceId],
    queryFn: () =>
      AdminScanSequencesService.getScanSequenceById(scanSequenceId!),
    enabled: !!scanSequenceId,
  });
}
